import React, { ReactElement, forwardRef, useState } from "react";
import styles from "./installmentTable.module.scss";
import { type IContent } from "@kunduz/data-access-cms-api";
import { Text } from "@kunduz/ui-atoms";
import { useTranslation } from "next-i18next";

export const PlanDetailInstallmentTable = forwardRef(
  (props: Props, ref: any): ReactElement => {
    const { t } = useTranslation("kunduzcom_common");
    const [visibleTab, setVisibleTab] = useState(
      props.data?.installments?.at(0),
    );

    return (
      <div ref={ref}>
        {props.data?.installments != undefined &&
          props.data?.installments?.length > 1 && (
            <div className={styles.toggleArea}>
              <div className={styles.toggleWrapper}>
                {props.data?.installments?.map((item, i) => (
                  <button
                    data-selected={visibleTab?.title === item.title}
                    key={`toggle_${i}`}
                    onClick={(e) => setVisibleTab(item)}
                  >
                    <Text variant="textsm" weight="semibold">
                      {item.title}
                    </Text>
                    {item.sub_title && (
                      <Text variant="textxs">{item.sub_title}</Text>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}

        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t("package_detail_installment_count_label")}</th>
              <th>{t("package_detail_installment_amount_label")}</th>
              <th>{t("package_detail_installment_total_amount_label")}</th>
            </tr>
          </thead>
          <tbody>
            {visibleTab?.installment_options &&
              Object.keys(visibleTab.installment_options).map((rowKey, i) => (
                <tr key={`row_${i}`}>
                  <td>
                    <div>
                      {rowKey === "1" ? (
                        t("paid_in_advance_label")
                      ) : (
                        <>
                          {rowKey} {t("package_detail_installment_label")}
                        </>
                      )}
                    </div>
                    {visibleTab.installment_options[rowKey]
                      .is_interest_free && (
                      <div
                        className={styles.interestFreeBadge}
                        style={{
                          backgroundColor: visibleTab.highlight_text_bg_color,
                        }}
                      >
                        {visibleTab.highlight_text}
                      </div>
                    )}
                  </td>
                  <td>
                    {visibleTab.installment_options[rowKey].installment_amount}
                  </td>
                  <td>{visibleTab.installment_options[rowKey].price}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className={styles["bankIcons"]}>
          <img src="/images/footerBankIcons/visa.png" alt="" loading="lazy" />
          <img
            src="/images/footerBankIcons/mastercard.png"
            alt=""
            loading="lazy"
          />
          <img src="/images/footerBankIcons/troy.png" alt="" loading="lazy" />
          <img
            src="/images/footerBankIcons/maximum.png"
            alt=""
            loading="lazy"
          />
          <img
            src="/images/footerBankIcons/bonuscard.png"
            alt=""
            loading="lazy"
          />
          <img src="/images/footerBankIcons/axess.png" alt="" loading="lazy" />
          {/* <img
            src="/images/footerBankIcons/yapikredi.png"
            alt=""
            loading="lazy"
          /> */}
          <img
            src="/images/footerBankIcons/finanscard.png"
            alt=""
            loading="lazy"
          />
          <img
            src="/images/footerBankIcons/advantage.png"
            alt=""
            loading="lazy"
          />
          <img src="/images/footerBankIcons/paraf.png" alt="" loading="lazy" />
        </div>
      </div>
    );
  },
);

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
